import { InjectionToken } from '@angular/core';

/**
 * Shape of an app's API configuration (user or admin).
 *
 * `baseUrl`, `baseUrlAuth` and `baseUrlUser` are the only endpoints there are. An earlier
 * revision carried `*Fallback` siblings and an `ApiFailoverService` that switched to a second
 * registrable domain (*.lexplus.ch → *.digitalemenschen.dev) once the primary became
 * unreachable. Both are gone: that second domain made every request cross-site, which forced
 * the session cookies to `SameSite=None` — the cookie class Safari already blocks and Chrome is
 * retiring. One domain per environment buys `SameSite=Lax` instead, and an availability
 * mechanism that silently drops the session in the browsers people use was not worth the trade.
 */
export interface ApiConfiguration {
  baseUrl: string;
  baseUrlAuth: string;
  baseUrlUser: string;
  publicApiKey: string;
}

/**
 * DI token for the active API configuration. Each app provides it with its own
 * environment configuration (user → `environmentUser`, admin →
 * `environmentAdmin`) so that shared services such as the interceptor are not
 * bound to a specific app.
 */
export const API_CONFIGURATION = new InjectionToken<ApiConfiguration>('API_CONFIGURATION');
